// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"dd1169ee","506":"bd5e74e8","707":"490df2d7"}[chunkId] + ".js";
};